<template>
  <v-container class="grey lighten-5" v-if="course">
    <h1>Kurs: {{ course.title }}</h1>
    <!--
        <VueHtml2pdf
            :show-layout="true"
            :float-layout="false"
            :enable-download="true"
            :preview-modal="true"
            filename="myPDF"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            pdf-content-height="700px"
            ref="html2Pdf"
        >
          <section slot="pdf-content">
            <div>
              <drag-it-dude style="position: absolute; z-index: 9999">
                <div style="height: 150px; width: 150px; background: fuchsia"></div>
              </drag-it-dude>
              <VuePdfEmbed :source="pdf"/>
            </div>
          </section>
        </VueHtml2pdf>
        -->
    <v-dialog v-model="askDeleteCourse" width="500">
      <v-card>
        <v-card-title>Wirklich löschen?</v-card-title>
        <v-card-text>
          <div>Der Kurs wird aus Benutzer- und Firmenübersichten entfernt. Bereits ausgestellte Zertifikate bleiben erhalten.</div>
          <v-progress-linear v-if="deleteImpactLoading" indeterminate color="indigo" class="mt-4 mb-2"/>
          <div v-else-if="deleteImpact" class="mt-4">
            <div>Betroffene Nutzer: {{ deleteImpact.affectedUsers }}</div>
            <div>Zu entfernende Kursläufe: {{ deleteImpact.affectedCourseRuns }}</div>
            <div>Zu entfernende Lizenzen: {{ deleteImpact.affectedLicenses }}</div>
            <div>Zu entfernende Live-Kurse: {{ deleteImpact.affectedLiveCourses }}</div>
            <div>Erhaltene Zertifikate: {{ deleteImpact.retainedCertificates }}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="askDeleteCourse = false">Abbrechen</v-btn>
          <v-btn color="red" :loading="loading" :disabled="deleteImpactLoading" @click="finallyDeleteCourse()">
            Endgültig aus Portal entfernen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <br/>
    <h2>Allgemeine Informationen</h2>
    <v-checkbox v-model="course.isLocked" label="Gesperrt"/>
    <v-text-field v-model="course.title" label="Titel"/>
    <v-text-field v-model="course.time" label="Zeitlimit in Minuten" type="number"/>
    <v-text-field v-model="course.imageRef" label="Bild"/>
    <v-text-field v-model="course.shopLink" label="Shop-Link"/>
    <br/>
    <v-divider></v-divider>
    <br/>
    <h2>Inhalt</h2>
    <v-checkbox v-model="course.isCompound" label="Zusammengesetzter Kurs"/>
    <div v-if="!course.isCompound">
      <v-autocomplete
          clearable
          outlined
          persistent-hint
          small-chips
          solo
          :items="coursePackages"
          v-model="course.zipName"
          label="Schulungspaket"
      />
    </div>
    <div v-else>
      <div v-for="part in course.parts" :key="part.key">
        <v-card style="margin-bottom: 16px;">
          <v-card-title>{{ part.name }}</v-card-title>
          <div style="margin: 16px">
            <v-text-field v-model="part.name" label="Titel"/>
            <label>Reihenfolge</label>
            <v-autocomplete
                persistent-hint
                small-chips
                solo
                :items="[1,2,3,4,5,6,7,8,9,10]"
                v-model="part.order"
                label="Reihenfolge (Gleich = Reihenfolge egal)"
            />
            <!--  <label>Abschlusswertung</label>
              <v-autocomplete
                  persistent-hint
                  small-chips
                  solo
                  :items="['AUTO', 'MANUAL', 'FROM_STORAGE']"
                  v-model="part.verificationType"
                  label="Abschlusswertung"
              />
              <label>Abfrage Typ</label>
              <v-autocomplete
                  persistent-hint
                  small-chips
                  solo
                  :items="['STORAGE', 'SHIPPERS_DECLARATION', 'QUESTIONS', 'DECLARED_GOODS']"
                  v-model="part.stepType"
                  label="Abfrage Type"
              /> -->
            <v-autocomplete
                persistent-hint
                small-chips
                solo
                :items="['STORAGE', 'SHIPPERS_DECLARATION', 'QUESTIONS', 'DECLARED_GOODS']"
                v-model="part.stepType"
                label="Typ"
            />
            <v-autocomplete
                v-if="part.isStepTypeStorage"
                clearable
                outlined
                persistent-hint
                small-chips
                solo
                :items="coursePackages"
                v-model="part.storageId"
                label="Schulungspaket"
            />
          </div>
          <v-card-actions>
            <v-btn @click="removePart(part)">Löschen</v-btn>
          </v-card-actions>
        </v-card>

      </div>
      <br/>
      <v-btn class="ma-1" color="info" @click="addPart">Neuen Teil anlegen</v-btn>
    </div>
    <br/>
    <v-divider></v-divider>
    <br/>
    <h2>Anhänge</h2>
    <v-autocomplete
        clearable
        multiple
        outlined
        persistent-hint
        small-chips
        :items="availablePdfs"
        v-model="course.pdfs"
        label="Anhänge"
    />
    <br/>
    <v-divider></v-divider>
    <br/>
    <h2>Schulungsspezifische Informationen</h2>
    <v-checkbox v-model="course.requireBirthdate" label="Erfordert angegebenes Geburtsdatum des Teilnehmers"/>
    <v-checkbox v-model="course.requireZvuExpirationDate"
                label="Erfordert gültige Zuverlässigkeitsüberprüfung (ZVÜ) des Teilnehmers"/>
    <v-checkbox v-model="course.requireIsHimself"
                label="Erfordert Persönlichkeitsbestätigung des Teilnehmers durch den Administrator"/>
    <v-btn class="ma-1" :loading="loading" :disabled="loading" color="info" @click="save">
      <div v-if="isNew">Anlegen</div>
      <div v-else>Speichern</div>
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>
    <div v-if="!isNew">
      <v-btn @click="openDeleteDialog" class="ma-2" outlined
             color="red">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </div>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top app>{{ errorText }}</v-snackbar>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>{{ successText }}</v-snackbar>
  </v-container>
</template>

<script>

import Course from "@/models/Course";
import CompoundCourseRunStep from "@/models/CompoundCourseRunStep";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import DragItDude from 'vue-drag-it-dude/src/DragItDude.vue';
import VueHtml2pdf from 'vue-html2pdf'
import constants from "@/util/constants";

export default {
  components: {
    VuePdfEmbed,
    DragItDude,
    VueHtml2pdf
  },
  name: "courseEdit",
  props: {
    courseId: {
      type: String
    }
  },
  computed: {
    isNew() {
      return this.courseId === "-1";
    },
  },
  data: () => ({
    askDeleteCourse: false,
    coursePackages: [],
    availablePdfs: [],
    deleteImpact: null,
    deleteImpactLoading: false,
    errorText: "",
    error: false,
    success: false,
    loading: false,
    successText: "",
    course: {
      type: Course
    },
    pdf: constants.aPdf
  }),
  mounted() {
    this.$httpCoursePackageApi.getAll((packages) => {
      this.coursePackages = packages;
      if (!this.isNew) {
        this.$httpCourseApi.get(this.courseId, (data) => {
          this.course = data;

          this.$httpPdfStorageApi.getAll((availablePdfs) => {
            this.availablePdfs = availablePdfs;
          })

        })
      } else {
        this.course = new Course();
      }
    })
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    addPart() {
      let newStep = new CompoundCourseRunStep();
      newStep.empty();
      this.course.parts.push(newStep);
    },
    removePart(part) {
      const index = this.course.parts.indexOf(part);
      this.course.parts.splice(index, 1);
    },
    openDeleteDialog() {
      this.askDeleteCourse = true;
      this.deleteImpact = null;
      this.deleteImpactLoading = true;
      this.$httpCourseApi.getPurgePreview(this.course.id, (result) => {
        this.deleteImpact = result;
        this.deleteImpactLoading = false;
      }, () => {
        this.errorText = "Auswirkungen konnten nicht geladen werden."
        this.error = true;
        this.deleteImpactLoading = false;
        setTimeout(() => this.error = false, 3000);
      })
    },
    finallyDeleteCourse() {
      this.loading = true;
      this.$httpCourseApi.purge(this.course.id, () => {
        this.successText = "Aus dem Portal entfernt. Zertifikate blieben erhalten."
        this.success = true;
        this.loading = false;
        this.askDeleteCourse = false;
        setTimeout(() => this.success = false, 3000);
        this.$emit("deleted", this.course)
      }, () => {
        this.errorText = "Fehler beim Löschen."
        this.error = true;
        this.loading = false;
        setTimeout(() => this.error = false, 3000);
      })
    },
    save() {
      if (!this.course.isValid()) {
        this.errorText = "Bitte Titel prüfen.";
        this.error = true;
        setTimeout(() => this.error = false, 5000);
        return
      }
      this.loading = true;
      let callbackSuccess = () => {
        this.successText = "Gespeichert."
        this.success = true;
        this.loading = false;
        setTimeout(() => this.success = false, 3000);
      };
      let callbackError = () => {
        this.errorText = "Fehler beim Speichern."
        this.error = true;
        this.loading = false;
        setTimeout(() => this.error = false, 3000);
      }
      if (this.isNew) {
        this.$httpCourseApi.create(this.course, (course) => {
          callbackSuccess();
          this.$emit("finish", course)
        }, callbackError)
      } else {
        this.$httpCourseApi.update(this.course, callbackSuccess, callbackError)
      }
    },
  }
}
</script>

<style scoped>

</style>
